import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { setEvent, setConnected, setError } from "@src/reducers/sse-slice";
import { useSSESubscription } from "@src/hooks/use-sse-subscription";
import { vpnManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { useI18N } from "@src/language/language-context";

export interface ServiceVpnManagerSSEData {
  action?: string;
  session_id?: string;
  source_id?: string;
  event_type?: string;
}

const SERVICE = "service-vpn-manager";

export const useServiceVPNManagerSSE = () => {
  const i18n = useI18N();
  const texts = {
    vpnManagerErrorText: i18n("modules.sse.vpnManagerErrorText"),
  };
  const dispatch = useDispatch();

  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const namespace = authContext?.customerNamespace;

  const baseURL = vpnManagerUrlEnvVar();

  useSSESubscription({
    url: `${baseURL}/api/v1/ns/${namespace}/events`,
    service: SERVICE,
    events: [
      {
        eventType: "support_session",
        onEvent: (data: ServiceVpnManagerSSEData) => {
          if (data.action === "interrupt" && data.session_id) {
            const channel = new BroadcastChannel("vnc-interrupt");
            channel.postMessage({
              type: "VNC_INTERRUPT",
              sessionId: data.session_id,
            });
            channel.close();
          }

          dispatch(
            setEvent({
              service: SERVICE,
              eventType: "support_session",
              data,
            }),
          );
        },
      },
    ],

    onOpen: () => {
      dispatch(setConnected({ service: SERVICE, status: true }));
    },

    onError: () => {
      dispatch(setConnected({ service: SERVICE, status: false }));
      dispatch(
        setError({
          service: SERVICE,
          hasError: true,
          message: texts.vpnManagerErrorText,
        }),
      );
    },
  });
};
